import { TweenMax } from "gsap";
import "../plugins/hair.js";

export default {
  init() {
    //Bubbles

    $('.bubble-box__bubble').each(function(){
      let randomPosition = rng(-200, 200)
      let that = this;
      $("body").mousemove(function(e) {
        parallaxIt(e, that, randomPosition);
      });
    })


    //Parallax
    function parallaxIt(e, target, movement) {
      let $this = $("body");
      let relX = e.pageX - $this.offset().left;
      let relY = e.pageY - $this.offset().top;

      TweenMax.to(target, 1, {
        x: (relX - $this.width() / 2) / $this.width() * movement,
        y: (relY - $this.height() / 2) / $this.height() * movement,
      });
    }

    function rng(min, max){
        //random nr generator
        return Math.floor(Math.random() * (1 + max - min) + min)
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js